var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "subscription-page__content" },
    [_c("subscription-terms-text")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }